export default "__VITE_ASSET__6WTip0ps__"